<template>
  <div class="sidebar-component-wrapper">
    <div class="title">
      <h6>{{ title }}</h6>
    </div>

    <div class="items-wrapper">
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Sidebar',

    props: {
      title: String,
    }
  }
</script>

<style scoped lang="scss">
  .sidebar-component-wrapper {
    width: 100%;
    border-radius: 25px;
    -moz-box-shadow: 0 0 3px #cecece;
    -webkit-box-shadow: 0 0 3px #cecece;
    box-shadow: 0 0 3px #cecece;
    margin-bottom: 60px;
    background-color: #60be6f;

    &.KMK-color {
      background-color: #192e5b;
    }

    &.RDV-color {
      background-color: #1e65a7;
    }

    &.PRM-color {
      background-color: #73a2c0;
    }

    &.RPT-color {
      background-color: #00743f;
    }

    &.INB-color {
      background-color: #f1a104;
    }

    &.NBR-color {
      background-color: #9a1c1c;
    }

    .title {
      width: 100%;
      font-style: italic;
      color: white;

      h6 {
        font-size: 16px;
        font-weight: normal;
        font-style: italic;
        margin: 0;
        padding: 10px 0 10px 20px;
      }
    }

    .items-wrapper {
      width: 100%;
      min-height: 200px;
      padding: 30px 10px;
      border-radius: 25px;
      background-color: white;
    }
  }
</style>
